module.exports = __webpack_public_path__ + "static/media/woman.c0920133.png";